module.exports = {
      id: "print-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/icons.0a12b861.svg#print-usage",
      toString: function () {
        return this.url;
      }
    }